import React, { useState } from "react";
import FormIntro from "./FormIntro";
import SearchForm from "../../../common/Components/SearchForm/SearchForm";
import banner from "../../../common/images/banner.png";

const Search = ({ airports }) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      {/* Preload for faster LCP */}
      <link rel="preload" as="image" href={banner} fetchpriority="high" />

      <div className="relative flex flex-col w-full min-h-screen px-3 md:px-10 md:pt-10 bg-[#00261E]">
        {/* Background image only for tablet and larger screens */}
        <img
          src={banner}
          alt="Airport Parking Hero Banner - Smart Deals Happy Travels"
          fetchpriority="high"
          className="absolute inset-0 hidden object-cover object-center w-full h-full small:block z-20"
        />

        <div className="relative z-[30] search-container py-10">
          <div className="max-w-[1400px] mx-auto flex flex-col items-center justify-center">
            <FormIntro />
            <SearchForm
              airports={airports}
              refer="/search"
              open={open}
              setOpen={setOpen}
            />
          </div>
        </div>

        {/* Theme toggle (optional) */}
        {/* 
        <div className="absolute items-center justify-end hidden md:flex top-5 right-10">
          <ThemeToggle />
        </div> 
        */}
      </div>
    </>
  );
};

export default Search;

